<template>
	<div class="ProgrammeFacts">
		<Tag
			v-for="(chip, index) in chips"
			:key="`standard-${index}`"
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '4.25rem', height: '1.5rem' },
				}
			}"
			:label="chip.label"
			:counter="chip.counter"
		/>

		<Tag
			v-for="(highlightedFact, index) in highlightedFacts"
			:key="`highlighted-${index}`"
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '4.25rem', height: '1.5rem' },
				}
			}"
			:label="highlightedFact"
			variant="highlighted"
		/>

	</div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import { computed } from 'vue';
import Tag from '@components/Tag/Tag.vue';
import type IFact from "@shared/interfaces/dtos/IFact";


const props = defineProps({
	facts: {
		type: Array as PropType<IFact[] | undefined>,
		default: () => [],
	},
	highlightedFacts: {
		type: Array as PropType<string[]>,
		default: () => [],
	},
	loading: {
		type: Boolean,
		default: false,
	},
});

const placeholderChips = computed(() => Array.from({ length: 3 }, () => ({ label: '', counter: undefined as number | undefined })));

const chips = computed(() => {
	const factChips = (props.facts ?? []).map(fact => ({
		label: fact.value,
		counter: fact.items?.length > 1 ? fact.items.length : undefined,
	}));


	if (props.loading && factChips.length === 0) {
		return placeholderChips.value;
	}

	return [...factChips];
});
</script>

<style scoped lang="scss">
	.ProgrammeFacts {
		display: flex;
		gap: 0.25rem;
		width: 100%;

		flex-wrap: wrap;
		max-height: calc(2 * 1.65rem);
		overflow: hidden;

		@include MarginAreas(0.5, 0, 0, 0);

		@include Breakpoint(Large, ExtraLarge) {
			width: 80%;

			@include MarginAreas(0.5, 0);
		}
	}
</style>
